jQuery(document).ready(function($){
  var printbtn = '<input class="mapjob-button" type="button" name="print" value="Drucken" onClick="window.print()">';
  
  $('#print-button').append(printbtn);
});